// extracted by mini-css-extract-plugin
module.exports = {"root":"_15fuL","left":"_2rUrG","right":"_2_u9e","small":"rt_Q4","normal":"h8PEn"};